import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

function Claims() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/territory-claims").then(({ data }) => setRows(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const decide = async (uid, approve) => {
    try { await api.post(`/admin/territory-claims/${uid}`, { approve }); toast.success(approve ? "Approved" : "Rejected"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="rounded-2xl border border-border bg-card p-5" data-testid="territory-claims">
      <h3 className="font-display font-bold text-sam-navy mb-2">Territory claims</h3>
      {rows.length === 0 ? <p className="text-sm text-sam-slate" data-testid="territory-claims-empty">No pending claims.</p> : rows.map((r) => (
        <div key={r.user_id} className="flex items-center justify-between gap-2 border-b border-border/50 py-2 text-sm" data-testid={`claim-${r.user_id}`}>
          <span><b className="text-sam-navy">{r.name || r.email}</b> <span className="font-mono text-xs">({r.referly_code})</span> wants <span className="font-mono">{(r.territory_pending || []).join(", ")}</span></span>
          <span className="flex gap-1">
            <Button size="sm" className="h-7 text-xs bg-sam-green" onClick={() => decide(r.user_id, true)} data-testid={`claim-approve-${r.user_id}`}>Approve</Button>
            <Button size="sm" variant="outline" className="h-7 text-xs" onClick={() => decide(r.user_id, false)} data-testid={`claim-reject-${r.user_id}`}>Reject</Button>
          </span>
        </div>
      ))}
    </div>
  );
}

function Scripts() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/partner-scripts").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return null;
  const save = async () => { try { await api.put("/admin/partner-scripts", s); toast.success("Partner scripts saved"); } catch { toast.error("Failed"); } };
  return (
    <div className="rounded-2xl border border-border bg-card p-5 space-y-2" data-testid="partner-scripts">
      <h3 className="font-display font-bold text-sam-navy">Partner first-steps content</h3>
      <label className="text-xs font-semibold text-sam-navy">Approved Video Sales Letter script (customer video)</label>
      <Textarea value={s.customer_vsl} onChange={(e) => setS({ ...s, customer_vsl: e.target.value })} className="min-h-[120px] text-xs" data-testid="partner-script-vsl" />
      <label className="text-xs font-semibold text-sam-navy">Approved compensation plan script (partner opportunity video)</label>
      <Textarea value={s.partner_comp} onChange={(e) => setS({ ...s, partner_comp: e.target.value })} className="min-h-[120px] text-xs" data-testid="partner-script-comp" />
      <label className="text-xs font-semibold text-sam-navy">Prospect hub link (where partners manage prospects)</label>
      <Input value={s.hub_url} onChange={(e) => setS({ ...s, hub_url: e.target.value })} placeholder="https://..." className="h-8 text-xs" data-testid="partner-script-hub" />
      <Button size="sm" className="bg-sam-navy" onClick={save} data-testid="partner-scripts-save">Save</Button>
    </div>
  );
}

export default function PartnerAdmin() {
  return <div className="space-y-4 mb-6"><Claims /><Scripts /></div>;
}
